$('#customselect').selectize();
$('#customselectauto').selectize();
$('#customselectsmall').selectize();
$('#customselectsm').selectize();
